<template>
  <v-menu
      ref="menu_flag"
      v-model="open"
      :close-on-content-click="false"
      :return-value.sync="inside_value"
      transition="scale-transition"
      offset-y
      min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-mask="'##:##'"
        ref="text_value"
        v-model="inside_value"
        :label="label"
        :rules="getFormatRules()"
        :hint="description || hint"
        :outlined="outlined"
        :persistent-hint="!!description || !!hint"
        :error="error"
        :error-messages="errorMessages"
        :loading="loading"
        :readonly="readonly"
        @focus="$emit('focus', $event)"
      >
        <template v-slot:append-outer v-if="downloadable">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                  v-on="on"
                  icon
                  @click="$emit('download')"
              >
                <v-icon>file_download</v-icon>
              </v-btn>
            </template>
            <span>Загрузить документ</span>
          </v-tooltip>
        </template>
        <template v-slot:prepend-inner>
          <v-icon v-bind="attrs" v-on="on">watch_later</v-icon>
        </template>
        <template v-slot:label>
          <slot name="label">
            {{label}}<span v-if="required" class="red--text">*</span>:
          </slot>
        </template>
      </v-text-field>
    </template>
    <v-card>
      <v-card-text class="picker-header">
        <div class="current-time">{{ formatDisplayTime(inside_value) }}</div>
      </v-card-text>
      <v-divider></v-divider>
      <div class="time-picker">
        <v-time-picker
          v-model="inside_value"
          format="24hr"
          scrollable
          :readonly="readonly"
          ref="timePicker"
        >
        </v-time-picker>
      </div>
      <v-divider></v-divider>
      <v-card-actions class="actions">
        <v-btn
          text
          @click="clearTime"
          class="action-btn"
        >
          Очистить
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="open = false"
          class="action-btn"
        >
          Отмена
        </v-btn>
        <v-btn
          color="primary"
          @click="saveTime"
          class="action-btn"
        >
          Применить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "TimePicker",
  props: {
    value: {
      required: true
    },
    downloadable: {
      type: Boolean,
      default: false,
    },
    label: {
      required: true
    },
    description: {
      required: false
    },
    hint: {
      required: false
    },
    required: {
      required: false,
      default: false,
      type: Boolean
    },
    outlined: {
      required: false,
      default: false,
      type: Boolean
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    },
    error: {
      type: Boolean,
      required: false,
      default: false,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data(){
    return {
      date_regex: /[0-9][0-9]:[0-9][0-9]/,
      open: false,
      inside_value: this.value,
    }
  },
  watch: {
    inside_value(){
      this.$emit('input', this.inside_value)
      this.$emit('focus', this.inside_value)
    },
    open(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.selectHourSection();
        });
      }
    }
  },
  methods: {
    getFormatRules(){
      let rules = [
        ...this.rules,
        v => (this.date_regex.test(v) || v === '') || 'Неправильный формат времени. Используйте формат hh:mm',
      ]
      if (this.required) {
        rules.push(v => (!!v) || 'Поле обязательно к заполнению')
      }
      return rules
    },
    saveTime() {
      if (this.$refs.menu_flag) {
        this.$refs.menu_flag.save(this.inside_value);
      }
      this.$emit('save', this.inside_value);
    },

    clearTime() {
      this.inside_value = '';
      this.$emit('input', '');
      this.$emit('clear');
      this.selectHourSection()
    },

    formatDisplayTime(time) {
      if (!time) return 'Не указано';
      const [hours, minutes] = time.split(':');
      return `${hours.padStart(2, '0')}:${minutes}`;
    },

    selectHourSection() {
      const timePicker = this.$refs.timePicker;
      if (timePicker) {
        const hoursButton = timePicker.$el.querySelector('.v-picker__title__btn');
        if (hoursButton) {
          hoursButton.click();
        }
      }
    },
    validate(show_messages=true) {
      return this.$refs['text_value'].validate(show_messages)
    },
  }
}
</script>

<style scoped>
.picker-header {
  padding: 24px;
  background-color: #1976D2;
  color: #fff !important;
}
.current-time {
  font-size: 36px !important;
  font-weight: 500 !important;
}
.time-picker ::v-deep .v-picker__title {
  display: none !important;
}

</style>
